import { styled } from "@mui/material";
import { Box } from "@mui/material";

export const LoaderRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  zIndex: 15,
  width: "100%",
  height: "100%",
}));

export const DotsCotainer = styled(Box)(({ theme }) => ({
  fontSize: "2rem",
  "& .loader__loading__dot": {
    margin: "0 1px",
    "&:nth-of-type(1)": {
      animation: "opacityDots1 3s infinite forwards ease",
    },
    "&:nth-of-type(2)": {
      animation: "opacityDots2 3s infinite forwards ease",
    },
    "&:nth-of-type(3)": {
      animation: "opacityDots3 3s infinite forwards ease",
    },
  },
  "@keyframes opacityDots1": {
    "0%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots2": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots3": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 0,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
}));
